import { Box, Button } from '@factorialco/deprecated-design-system'
import {
  AtsGetApplicationsSourceInsightsDocument,
  AtsInsightsMetricsFilterFragment,
} from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { ApplicationsSourceChart } from 'modules/ats/components/Insights/ApplicationsSourceChart'
import { ApplicationsSourceTypeChart } from 'modules/ats/components/Insights/ApplicationsSourceTypeChart'
import { DataNotAvailable } from 'modules/ats/components/Insights/DataNotAvailable'
import { LastUpdatedAt } from 'modules/ats/components/Insights/LastUpdatedAt'
import { useExportUrlParams } from 'modules/ats/lib/utils/insights'
import { MetricsFilters } from 'modules/ats/pages/InsightsPage/MetricsFilters'
import { useMetricsFilters } from 'modules/ats/pages/InsightsPage/MetricsFiltersProvider'

interface Props {
  atsCompanyId: number
  jobs: AtsInsightsMetricsFilterFragment[]
}

export const SourcesMetrics = ({ atsCompanyId, jobs }: Props) => {
  const { filters } = useMetricsFilters()
  const { exportUrlParams } = useExportUrlParams({ atsCompanyId, filters })
  const { loading, data, error } = useQuery(AtsGetApplicationsSourceInsightsDocument, {
    variables: { ...filters, atsCompanyId },
  })

  const applicationsSourceData = data?.ats.applicationsSourceInsightsConnection.nodes || []

  const exportUrl = () =>
    buildUrl(
      `/ats/insights/applications_sources?${new URLSearchParams(exportUrlParams).toString()}`
    )

  useEffect(() => {
    track(trackingEvents.ats.insightsSourcesView)
  }, [])

  const lastUpdatedAts = data?.ats.lastUpdatedAtInsightsConnection.nodes
  return (
    <Box paddingY="s24" gap="s24">
      <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
        <Box flexDirection="row" gap="s16" flexWrap="wrap">
          <MetricsFilters jobs={jobs} />
          <LastUpdatedAt lastUpdatedAts={lastUpdatedAts} id={'applications'} />
        </Box>

        <Button.Router
          to={exportUrl()}
          onClick={() => {
            track(trackingEvents.ats.insightsSourcesReportDownload)
          }}
          download
          iconName="download"
        >
          {i18n.t('common.export')}
        </Button.Router>
      </Box>
      {error?.message ? (
        <Box minHeight="s240" justifyContent="center">
          <DataNotAvailable />
        </Box>
      ) : (
        <>
          <ApplicationsSourceTypeChart
            applicationsSourceTypeData={applicationsSourceData}
            loading={loading}
          />
          <ApplicationsSourceChart
            applicationsSourceData={applicationsSourceData}
            loading={loading}
          />
        </>
      )}
    </Box>
  )
}
